import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DAppClient, PermissionScope } from '@airgap/beacon-sdk';
import { createTransferOperation, createOriginationOperation, createSetDelegateOperation } from '@taquito/taquito';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
} // IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!


var VERSION = {
  "commitHash": "81f0a5b103f867f57fbe5d526315c375a3788346",
  "version": "11.2.0"
};
/**
 * @packageDocumentation
 * @module @taquito/beacon-wallet
 */

var BeaconWalletNotInitialized = /*#__PURE__*/function (_Error) {
  _inherits(BeaconWalletNotInitialized, _Error);

  var _super = _createSuper(BeaconWalletNotInitialized);

  function BeaconWalletNotInitialized() {
    var _this;

    _classCallCheck(this, BeaconWalletNotInitialized);

    _this = _super.call(this, 'You need to initialize BeaconWallet by calling beaconWallet.requestPermissions first');
    _this.name = 'BeaconWalletNotInitialized';
    return _this;
  }

  return _createClass(BeaconWalletNotInitialized);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var MissingRequiredScopes = /*#__PURE__*/function (_Error2) {
  _inherits(MissingRequiredScopes, _Error2);

  var _super2 = _createSuper(MissingRequiredScopes);

  function MissingRequiredScopes(requiredScopes) {
    var _this2;

    _classCallCheck(this, MissingRequiredScopes);

    _this2 = _super2.call(this, "Required permissions scopes were not granted: ".concat(requiredScopes.join(',')));
    _this2.requiredScopes = requiredScopes;
    _this2.name = 'MissingRequiredScopes';
    return _this2;
  }

  return _createClass(MissingRequiredScopes);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var BeaconWallet = /*#__PURE__*/function () {
  function BeaconWallet(options) {
    _classCallCheck(this, BeaconWallet);

    this.client = new DAppClient(options);
  }

  _createClass(BeaconWallet, [{
    key: "validateRequiredScopesOrFail",
    value: function validateRequiredScopesOrFail(permissionScopes, requiredScopes) {
      var mandatoryScope = new Set(requiredScopes);

      var _iterator = _createForOfIteratorHelper(permissionScopes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var scope = _step.value;

          if (mandatoryScope.has(scope)) {
            mandatoryScope.delete(scope);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (mandatoryScope.size > 0) {
        throw new MissingRequiredScopes(Array.from(mandatoryScope));
      }
    }
  }, {
    key: "requestPermissions",
    value: function requestPermissions(request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.client.requestPermissions(request);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getPKH",
    value: function getPKH() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var account;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.getActiveAccount();

              case 2:
                account = _context2.sent;

                if (account) {
                  _context2.next = 5;
                  break;
                }

                throw new BeaconWalletNotInitialized();

              case 5:
                return _context2.abrupt("return", account.address);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "mapTransferParamsToWalletParams",
    value: function mapTransferParamsToWalletParams(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var walletParams;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.client.showPrepare();

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return params();

              case 5:
                walletParams = _context3.sent;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                _context3.next = 12;
                return this.client.hideUI();

              case 12:
                throw _context3.t0;

              case 13:
                _context3.t1 = this;
                _context3.t2 = walletParams;
                _context3.next = 17;
                return createTransferOperation(this.formatParameters(walletParams));

              case 17:
                _context3.t3 = _context3.sent;
                return _context3.abrupt("return", _context3.t1.removeDefaultParams.call(_context3.t1, _context3.t2, _context3.t3));

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));
    }
  }, {
    key: "mapOriginateParamsToWalletParams",
    value: function mapOriginateParamsToWalletParams(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var walletParams;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.client.showPrepare();

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return params();

              case 5:
                walletParams = _context4.sent;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                _context4.next = 12;
                return this.client.hideUI();

              case 12:
                throw _context4.t0;

              case 13:
                _context4.t1 = this;
                _context4.t2 = walletParams;
                _context4.next = 17;
                return createOriginationOperation(this.formatParameters(walletParams));

              case 17:
                _context4.t3 = _context4.sent;
                return _context4.abrupt("return", _context4.t1.removeDefaultParams.call(_context4.t1, _context4.t2, _context4.t3));

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));
    }
  }, {
    key: "mapDelegateParamsToWalletParams",
    value: function mapDelegateParamsToWalletParams(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var walletParams;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.client.showPrepare();

              case 2:
                _context5.prev = 2;
                _context5.next = 5;
                return params();

              case 5:
                walletParams = _context5.sent;
                _context5.next = 13;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
                _context5.next = 12;
                return this.client.hideUI();

              case 12:
                throw _context5.t0;

              case 13:
                _context5.t1 = this;
                _context5.t2 = walletParams;
                _context5.next = 17;
                return createSetDelegateOperation(this.formatParameters(walletParams));

              case 17:
                _context5.t3 = _context5.sent;
                return _context5.abrupt("return", _context5.t1.removeDefaultParams.call(_context5.t1, _context5.t2, _context5.t3));

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 8]]);
      }));
    }
  }, {
    key: "formatParameters",
    value: function formatParameters(params) {
      if (params.fee) {
        params.fee = params.fee.toString();
      }

      if (params.storageLimit) {
        params.storageLimit = params.storageLimit.toString();
      }

      if (params.gasLimit) {
        params.gasLimit = params.gasLimit.toString();
      }

      return params;
    }
  }, {
    key: "removeDefaultParams",
    value: function removeDefaultParams(params, operatedParams) {
      // If fee, storageLimit or gasLimit is undefined by user
      // in case of beacon wallet, dont override it by
      // defaults.
      if (!params.fee) {
        delete operatedParams.fee;
      }

      if (!params.storageLimit) {
        delete operatedParams.storage_limit;
      }

      if (!params.gasLimit) {
        delete operatedParams.gas_limit;
      }

      return operatedParams;
    }
  }, {
    key: "sendOperations",
    value: function sendOperations(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var account, permissions, _yield$this$client$re, transactionHash;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.client.getActiveAccount();

              case 2:
                account = _context6.sent;

                if (account) {
                  _context6.next = 5;
                  break;
                }

                throw new BeaconWalletNotInitialized();

              case 5:
                permissions = account.scopes;
                this.validateRequiredScopesOrFail(permissions, [PermissionScope.OPERATION_REQUEST]);
                _context6.next = 9;
                return this.client.requestOperation({
                  operationDetails: params
                });

              case 9:
                _yield$this$client$re = _context6.sent;
                transactionHash = _yield$this$client$re.transactionHash;
                return _context6.abrupt("return", transactionHash);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     *
     * @description Removes all beacon values from the storage. After using this method, this instance is no longer usable.
     * You will have to instanciate a new BeaconWallet.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.client.destroy();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     *
     * @description This method removes the active account from local storage by setting it to undefined.
     */

  }, {
    key: "clearActiveAccount",
    value: function clearActiveAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.client.setActiveAccount();

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }]);

  return BeaconWallet;
}();

export { BeaconWallet, BeaconWalletNotInitialized, MissingRequiredScopes, VERSION };